import type { VirtualAppointmentStatus } from '../../../services/virtualAppointments';
import { OPEN_STATUS_OPTIONS } from '../../virtual-appointments/openVirtualAppointments';
import { BY_DUE_DATE, NEWEST_FIRST, type OverviewSort } from './overviewSort';

export type OverviewTab = 'open' | 'upcoming' | 'previous';

export interface OverviewTabConfig {
    value: OverviewTab;
    label: string;
    statuses: readonly VirtualAppointmentStatus[];
    defaultSort: OverviewSort;
    showClosed: boolean;
    emptyTitle: string;
    emptyText: string;
}

export const OVERVIEW_TABS: readonly OverviewTabConfig[] = [
    {
        value: 'open',
        label: 'Open',
        statuses: OPEN_STATUS_OPTIONS,
        defaultSort: NEWEST_FIRST,
        showClosed: false,
        emptyTitle: 'No open VAs',
        emptyText: 'VAs show here once their trigger is reached or the team opens them.'
    },
    {
        value: 'upcoming',
        label: 'Upcoming',
        statuses: ['planned'],
        defaultSort: BY_DUE_DATE,
        showClosed: false,
        emptyTitle: 'No upcoming VAs',
        emptyText: 'Planned VAs show here until their aligner or week is reached.'
    },
    {
        value: 'previous',
        label: 'Previous',
        statuses: ['done', 'canceled'],
        defaultSort: NEWEST_FIRST,
        showClosed: true,
        emptyTitle: 'No previous VAs',
        emptyText: 'Done and canceled VAs show here.'
    }
];

export const DEFAULT_OVERVIEW_TAB: OverviewTab = 'open';

export function overviewTabConfig(tab: OverviewTab): OverviewTabConfig {
    return OVERVIEW_TABS.find((config) => config.value === tab) ?? OVERVIEW_TABS[0];
}
